import {URL_BASE_API } from '../../../configs/urlConfigs';

import service from '../../api';

export const keyLocationList = (request) => {     
    let ENDPOINT = URL_BASE_API+'affiliate/key-locations/';
    if(request.data!==undefined){    
      let search   = request.data.search;
      let column   = request.data.column;    
      let affiliateId =  request.data.affiliateId; 
      let sepVal = '?'; 
      if(affiliateId){
        ENDPOINT += sepVal+'affiliate='+affiliateId;
        sepVal = '&'; 
      }   
      else {
        if(column.length) {
          ENDPOINT += sepVal+'column='+column;
          sepVal = '&'; 
        }
        if(search.length){
          ENDPOINT += sepVal+'location='+search;
          sepVal = '&'; 
        }
      } 
    }
    return service.get(ENDPOINT);  
}; 

export const eventLocationList = (request) => {     
    let ENDPOINT = URL_BASE_API+'affiliate/event-locations/';
    if(request.data!==undefined){    
      let search   = request.data.search;
      let pageId   = request.data.page;
      let column   = request.data.column;
      let pageSize = request.data.pageSize;
      let affiliateId = request.data.affiliateId===null?'':request.data.affiliateId;    
      let sepVal = '?'; 
      if(affiliateId){
        ENDPOINT += sepVal+'affiliate='+affiliateId;
        sepVal = '&';
      }
      if(pageId>=0){
        ENDPOINT += sepVal+'page='+pageId;
        sepVal = '&';
      }
      if(column.length){
        ENDPOINT += sepVal+'column='+column;
        sepVal = '&';
      }
      if(search.length){
        ENDPOINT += sepVal+'location='+search;
        sepVal = '&';
      }
      if(pageSize){
        ENDPOINT += sepVal+'page_size='+pageSize;
        sepVal = '&';
      }

      // if(affiliateId){
      //   ENDPOINT = URL_BASE_API+'affiliate/event-locations/?page='+pageId+'&column='+column+'&location='+search+'&page_size='+pageSize+'&affiliate='+affiliateId;
      // }

      // if(column||pageId||search||pageSize || affiliateId===undefined){
      //   ENDPOINT = URL_BASE_API+'affiliate/event-locations/?page='+pageId+'&column='+column+'&location='+search+'&page_size='+pageSize;
      // }
      
    }

    return service.get(ENDPOINT);  
    
}; 

export const keyLocationAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/key-location/';
  
    return service.post(ENDPOINT,request.data);
    
};

export const eventLocationAdd = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/event-location/';
  
    return service.post(ENDPOINT,request.data);
    
};

export const keyLocationDelete = (request) => {
    let locId = request.data.locId;
    let confirm = request.data.confirm;
    let ENDPOINT = '';
    if(confirm!==undefined){
      ENDPOINT = URL_BASE_API+'affiliate/key-location/?key_location_id='+locId+'&delete_confirmation='+confirm;
    }else{
      ENDPOINT = URL_BASE_API+'affiliate/key-location/?key_location_id='+locId;
    }
    return service.delete(ENDPOINT);   
};

export const eventLocationDelete = (request) => {
    let locId = request.data.locId;
    let confirm = request.data.confirm;
    let ENDPOINT = '';
    if(confirm!==undefined){
      ENDPOINT = URL_BASE_API+'affiliate/event-location/?event_location_id='+locId+'&delete_confirmation='+confirm;
    }else{
      ENDPOINT = URL_BASE_API+'affiliate/event-location/?event_location_id='+locId;
    }
    return service.delete(ENDPOINT);   
};

export const eventLocationCsvImport = (request) => {
    const ENDPOINT = URL_BASE_API+'affiliate/event-locations-csv/';
    return service.post(ENDPOINT,request.data);   
};